export default __webpack_public_path__ + "static/media/contact-light.812df2c1.svg";